module.exports = __webpack_public_path__ + "static/ceo2-3654572f68de6e46777da7b7bb20058b.mp4";